import React from "react";
import PropTypes from "prop-types";

const ColorPicker = ({ colors, selected, onPick, hasError }) => {
    if (!colors || !colors.length)
        return <div className="text-muted small mb-2">No colors available.</div>;
    return (
        <div
            className="d-flex flex-wrap gap-2 mb-2 text-left"
            style={hasError ? { outline: "2px solid #dc3545", outlineOffset: "2px" } : {}}
        >
            {colors.map((c) => {
                const active = selected === c.Name;
                return (
                    <React.Fragment key={c.Name}>
                        <button
                            type="button"
                            onClick={() => onPick(c.Name)}
                            className={`border-0 position-relative p-0 color-chip ${active ? "shadow shadow-color-box" : ""}`}
                            style={{
                                width: 46,
                                height: 46,
                                borderRadius: 0,
                                backgroundColor: c.BackgroundColor,
                                border: active ? "3px solid #000" : `2px solid ${c.BorderColor}`,
                                cursor: "pointer",
                                transition: "transform .15s",
                                opacity: 1,
                                filter: "none",
                                boxSizing: "border-box",
                            }}
                            title={c.Name}
                            aria-label={`Select badge color: ${c.Name}`}
                            aria-pressed={active}
                        />&nbsp;
                    </React.Fragment>
                );
            })}
        </div>
    );
};

ColorPicker.propTypes = {
    colors: PropTypes.arrayOf(
        PropTypes.shape({
            Name: PropTypes.string.isRequired,
            BackgroundColor: PropTypes.string,
            BorderColor: PropTypes.string,
        })
    ),
    selected: PropTypes.string,
    onPick: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
};

ColorPicker.defaultProps = {
    colors: [],
    selected: "",
    hasError: false,
};

export default ColorPicker;
